import AccessDeniedPage from 'pages/access-denied';
import { AggregatedSheets } from 'pages/aggregated-sheets';
import AnalyticsPage from 'pages/analytics';
import BenchmarkingPage from 'pages/benchmarking';
import BnplPage from 'pages/bnpl';
import CatalogPage from 'pages/catalog';
import CategoriesPage from 'pages/categories';
import CountriesPage from 'pages/countries';
import CrmAccessControlManagementPage from 'pages/crm-access-control-management';
import CrmBrandContactDetailsPage from 'pages/crm-brand-contact-details';
import CrmBrandLocationsPage from 'pages/crm-brand-locations';
import CrmBrandTradeLicenseMappingsPage from 'pages/crm-brand-trade-license-mappings';
import CrmBrandsPage from 'pages/crm-brands';
import CrmCuisinesPage from 'pages/crm-cuisines';
import CrmDedDetailsPage from 'pages/crm-ded-details';
import CrmGoogleLocationsPage from 'pages/crm-google-locations';
import CrmMasterCuisinesPage from 'pages/crm-master-cuisines';
import CrmSourceBrandLocationsPage from 'pages/crm-source-brand-locations';
import CrmSupplierContactQuotasPage from 'pages/crm-supplier-contact-quotas';
import DocumentTypesPage from 'pages/document-types';
import ElkasoUsersPage from 'pages/elkasoUsers';
import ErpMappingsPage from 'pages/erp-mappings';
import ExclusiveDealsPage from 'pages/exclusive-deals';
import ExpiredSessionPage from 'pages/expired-session';
import ExpiredTokenPage from 'pages/expired-token';
import NotFoundPage from 'pages/general/not-found-page';
import GpoOrdersPage from 'pages/gpo-orders';
import InquiryProcessorPage from 'pages/inquiry-processor';
import InvoiceScanningPage from 'pages/invoice-scanning';
import LoginPage from 'pages/login';
import OrdersPage from 'pages/orders';
import PermissionsPage from 'pages/permissions';
import PocAgentCallsPage from 'pages/poc-agent-calls';
import PosIntegrationsPage from 'pages/pos-integrations';
import PricesPage from 'pages/prices';
import PriceImportsPage from 'pages/price-imports';
import ProductsPage from 'pages/products';
import ProfilePage from 'pages/profile';
import PromotionsPage from 'pages/promotions';
import ReconciliationPage from 'pages/reconciliation';
import RestaurantTransfersPage from 'pages/restaurant-transfers';
import RestaurantsPage from 'pages/restaurants';
import SalesLookupPage from 'pages/sales-lookup';
import SmsOtpPage from 'pages/sms-otp';
import StatisticsPage from 'pages/statistics';
import SupplierIntelligencePage from 'pages/supplier-intelligence';
import SupplierProfilesPage from 'pages/supplier-profiles';
import SuppliersPage from 'pages/suppliers';
import TicketManagementPage from 'pages/ticket-management';
import UnmatchedDemandPage from 'pages/unmatched-demand';
import UserManagementPage from 'pages/user-management';
import ValidationCodePage from 'pages/validation-code';
import WhatsNumbersPage from 'pages/whatsNumbers';
import { RouteProps } from 'react-router-dom';
// import { ability } from '../configs/ability';

// A.C: Routes after user logged in only
export const privateRoutes: RouteProps[] = [
  {
    path: '/app/user-management',
    component: UserManagementPage,
  },
  {
    path: '/app/benchmarking',
    component: BenchmarkingPage,
  },
  {
    path: '/app/Profile',
    component: ProfilePage,
  },
  {
    path: '/app/restaurants',
    component: RestaurantsPage,
  },
  {
    path: '/app/catalog',
    component: CatalogPage,
  },
  {
    path: '/app/suppliers',
    component: SuppliersPage,
  },
  {
    path: '/app/products',
    component: ProductsPage,
  },
  {
    path: '/app/agg-sheet-relations',
    component: AggregatedSheets,
  },
  {
    path: '/app/ticket',
    component: TicketManagementPage,
  },
  {
    path: '/app/elkasoUsers',
    component: ElkasoUsersPage,
  },
  {
    path: '/app/orders',
    component: OrdersPage,
  },
  {
    path: '/app/restaurant-transfers',
    component: RestaurantTransfersPage,
  },
  {
    path: '/app/pos-integrations',
    component: PosIntegrationsPage,
  },
  {
    path: '/app/erp-mappings',
    component: ErpMappingsPage,
  },
  {
    path: '/app/statistics',
    component: StatisticsPage,
  },
  {
    path: '/app/promotions',
    component: PromotionsPage,
  },
  {
    path: '/app/categories',
    component: CategoriesPage,
  },
  {
    path: '/app/exclusive-deals',
    component: ExclusiveDealsPage,
  },
  {
    path: '/app/prices',
    component: PricesPage,
  },
  {
    path: '/app/price-imports',
    component: PriceImportsPage,
  },
  {
    path: '/app/sales-lookup',
    component: SalesLookupPage,
  },
  {
    path: '/app/supplier-profiles',
    component: SupplierProfilesPage,
  },
  {
    path: '/app/reconciliation',
    component: ReconciliationPage,
  },
  {
    path: '/app/gpo-orders',
    component: GpoOrdersPage,
  },
  {
    path: '/app/inquiry-processor',
    component: InquiryProcessorPage,
  },
  {
    path: '/app/preferences',
    component: PermissionsPage,
  },
  {
    path: '/app/sms-otp',
    component: SmsOtpPage,
  },
  {
    path: '/app/whats-numbers',
    component: WhatsNumbersPage,
  },
  {
    path: '/app/countries',
    component: CountriesPage,
  },
  {
    path: '/app/analytics',
    component: AnalyticsPage,
  },
  {
    path: '/app/poc-agent-calls',
    component: PocAgentCallsPage,
  },
  {
    path: '/app/crm-cuisines',
    component: CrmCuisinesPage,
  },
  {
    path: '/app/crm-google-locations',
    component: CrmGoogleLocationsPage,
  },
  {
    path: '/app/crm-brands',
    component: CrmBrandsPage,
  },
  {
    path: '/app/crm-brand-locations',
    component: CrmBrandLocationsPage,
  },
  {
    path: '/app/crm-source-brand-locations',
    component: CrmSourceBrandLocationsPage,
  },
  {
    path: '/app/crm-brand-contact-details',
    component: CrmBrandContactDetailsPage,
  },
  {
    path: '/app/crm-brand-trade-license-mappings',
    component: CrmBrandTradeLicenseMappingsPage,
  },
  {
    path: '/app/crm-master-cuisines',
    component: CrmMasterCuisinesPage,
  },
  {
    path: '/app/crm-ded-details',
    component: CrmDedDetailsPage,
  },
  {
    path: '/app/crm-supplier-contact-quotas',
    component: CrmSupplierContactQuotasPage,
  },
  {
    path: '/app/crm-access-control-management',
    component: CrmAccessControlManagementPage,
  },
  {
    path: '/app/document-types',
    component: DocumentTypesPage,
  },
  {
    path: '/app/bnpl',
    component: BnplPage,
  },
  {
    path: '/app/invoice-scanning',
    component: InvoiceScanningPage,
  },
  {
    path: '/app/supplier-intelligence',
    component: SupplierIntelligencePage,
  },
  {
    path: '/app/unmatched-demand',
    component: UnmatchedDemandPage,
  },
];

// A.C: Routes before user logged in only
export const preLoginRoutes: RouteProps[] = [
  {
    path: '/login',
    component: LoginPage,
  },
  {
    path: '/validation-code',
    component: ValidationCodePage,
  },
];

// A.C: Routes for both logged in/out
export const publicRoutes: RouteProps[] = [
  {
    path: '/access-denied',
    component: AccessDeniedPage,
  },
  {
    path: '/expired-token',
    component: ExpiredTokenPage,
  },
  {
    path: '/expired-session',
    component: ExpiredSessionPage,
  },
  {
    path: '/404',
    component: NotFoundPage,
  },
];
